<template>
  <div id="custom-filter-container">
    <div class="custom-filter-group" v-for="(filter, index) in filters" :key="index">
      <div class="title">{{ filter.title }}</div>
      <div class="options" :class="[filter.type]">
        <template v-if="filter.type === 'input'">
          <div class="input-group">
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="text" :placeholder="(filter.placeholder || (() => ''))(filter)" v-model="conditions[filter.value]">
          </div>
        </template>
        <template v-if="filter.type === 'select'">
          <div class="input-group">
            <select @keydown.enter.prevent.stop="$emit('pressEnter')" v-model="conditions[filter.value]" :style="conditions[filter.value] ? {} : { color: '#a9a9a9' }" @change="e => (filter.onChange || (() => {}))(conditions[filter.value], conditions)">
              <option v-if="filter.placeholder" disabled value="">{{ filter.placeholder(filter) }}</option>
              <option v-for="(option, index) in filter.options.filter(filter.optionDisplay ? filter.optionDisplay(conditions) : (() => true))" :key="index" :value="option.value">{{ option.title }}</option>
            </select>
          </div>
        </template>
        <template v-if="filter.type === 'datalist'">
          <div class="input-group">
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="text" :list="filter.value + '-filter-lists'" :placeholder="(filter.placeholder || (() => ''))(filter)" @change="e => datalistOnChange(filter, conditions)" v-model="conditions[filter.value]">
            <template v-if="filter.customList">
              <div class="datalist" v-if="(filter.lists(conditions[filter.value], conditions) || []).length">
                <div class="option" v-for="(option) in filter.lists(conditions[filter.value], conditions)" :key="option + index" @click="e => conditions[filter.value] = option">{{ option }}</div>
              </div>
            </template>
            <template v-else>
              <datalist v-if="(filter.lists(conditions[filter.value], conditions) || []).length" :id="filter.value + '-filter-lists'">
                <option v-for="(option, index) in filter.lists(conditions[filter.value], conditions)" :key="index">{{ option }}</option>
              </datalist>
            </template>
          </div>
        </template>
        <template v-else-if="filter.type === 'single'">
          <div class="input-group" v-for="(option, index) in filter.options" :key="index">
            <label :for="filter.value + '_' + option.value">
              <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="radio" :id="filter.value + '_' + option.value" :name="filter.value" :value="option.value" v-model="conditions[filter.value]">
              <span>{{ option.title }}</span>
            </label>
          </div>
        </template>
        <template v-else-if="filter.type === 'multiple'">
          <div class="input-group" v-for="(option, index) in filter.options" :key="index">
            <label :for="filter.value + '_' + option.value" :class="{ disabled: filter.range && ((filter.range[0] === (conditions[filter.value] || []).length && conditions[filter.value].includes(option.value)) || (filter.range[1] === (conditions[filter.value] || []).length && !conditions[filter.value].includes(option.value))) }">
              <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="checkbox" :id="filter.value + '_' + option.value" v-show="false" :disabled="filter.range && ((filter.range[0] === (conditions[filter.value] || []).length && conditions[filter.value].includes(option.value)) || (filter.range[1] === (conditions[filter.value] || []).length && !conditions[filter.value].includes(option.value)))" :name="filter.value" :value="option.value" v-model="conditions[filter.value]">
              <img :src="require('../../assets/images/checkbox-' + ((conditions[filter.value] || []).includes(option.value) ? 'true' : 'false') + '.svg')">
              <span>{{ option.title }}</span>
            </label>
          </div>
        </template>
        <template v-else-if="filter.type === 'range'">
          <div class="input-group" v-if="conditions[filter.value]">
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="number" :step="filter.step" :min="filter.range ? filter.range[0] : null" :max="filter.range ? filter.range[1] : null" :placeholder="(filter.placeholder || (() => ['', '']))(filter)[0]" v-model="conditions[filter.value][0]">
            <span :style="{ opacity: 0, height: '5px' }">~</span>
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="number" :step="filter.step" :min="filter.range ? filter.range[0] : null" :max="filter.range ? filter.range[1] : null" :placeholder="(filter.placeholder || (() => ['', '']))(filter)[1]" v-model="conditions[filter.value][1]">
          </div>
        </template>
        <template v-else-if="filter.type === 'date'">
          <div class="input-group" v-if="conditions[filter.value]">
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="date" :min="filter.range ? filter.range[0] : null" :max="filter.range ? filter.range[1] : null" :style="conditions[filter.value][0] ? {} : { color: '#777777' }" :placeholder="filter.placeholder(filter)[0]" v-model="conditions[filter.value][0]">
            <span :style="{ opacity: 0, height: '5px' }">~</span>
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="date" :min="filter.range ? filter.range[0] : null" :max="filter.range ? filter.range[1] : null" :style="conditions[filter.value][1] ? {} : { color: '#777777' }" :placeholder="filter.placeholder(filter)[1]" v-model="conditions[filter.value][1]">
          </div>
        </template>
        <template v-else-if="filter.type === 'time'">
          <div class="input-group" v-if="conditions[filter.value]">
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="time" :min="filter.range ? filter.range[0] : null" :max="filter.range ? filter.range[1] : null" :style="conditions[filter.value][0] ? {} : { color: '#777777' }" v-model="conditions[filter.value][0]">
            <span :style="{ opacity: 0, height: '5px' }">~</span>
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="time" :min="filter.range ? filter.range[0] : null" :max="filter.range ? filter.range[1] : null" :style="conditions[filter.value][1] ? {} : { color: '#777777' }" v-model="conditions[filter.value][1]">
          </div>
        </template>
        <template v-else-if="filter.type === 'tags'">
          <div class="input-group">
            <input @keydown.enter.prevent.stop="$emit('pressEnter')" type="text" :ref="filter.value" :placeholder="(filter.placeholder || (() => ''))(filter)">
            <button @click="e => { conditions[filter.value] = conditions[filter.value].concat([$refs[filter.value][0].value]).filter((x, i, s) => s.indexOf(x) === i); $refs[filter.value][0].value = '' }">+</button>
          </div>
          <div class="input-group" v-for="(option, index) in conditions[filter.value]" :key="index">
            <label>
              <span>{{ option }}</span>
              <button @click="e => conditions[filter.value].splice(index, 1)">x</button>
            </label>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      type: Array,
      default: () => null
    },
    init: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      conditions: {},
      output: {}
    }
  },
  watch: {
    'datas' () {
      this.datas && this.$emit('filted', this.dataFilter(this.datas, this.output))
    },
    'init' () {
      this.initialConditions()
    },
    'filters' () {
      this.initialConditions()
    },
    'conditions': {
      handler: async function () {
        this.output = await this.afterTreatment(this.conditions)
        this.$emit('change', this.output)
        this.datas && this.$emit('filted', this.dataFilter(this.datas, this.output))
      },
      deep: true
    }
  },
  created () {
    this.initialConditions()
  },
  methods: {
    async initialConditions () {
      let input = await this.preTreatment(this.init)
      let initials = {
        input: () => '',
        datalist: () => '',
        select: () => '',
        single: () => '',
        multiple: () => [],
        range: () => ['', ''],
        date: () => ['', ''],
        time: () => ['', ''],
        tags: () => []
      }
      this.conditions = this.filters.reduce((s, c) => ({ ...s, ...{ [c.value]: input[c.value] || initials[c.type]() } }), {})
    },
    async preTreatment (init) {
      let input = {}
      for (let filter of this.filters) {
        input[filter.value] = await (filter.inputFormat || (async x => x))(init[filter.value])
      }
      return input
    },
    async afterTreatment (conditions) {
      let output = {}
      for (let filter of this.filters) {
        output[filter.value] = await (filter.outputFormat || (async x => x))(conditions[filter.value])
      }
      return output
    },
    dataFilter (datas, conditions) {
      const getDefaultFilter = type => {
        switch (type) {
          case 'input':
          case 'datalist': {
            return (d, c, f) => !c[f.value] || d[f.value].includes(c[f.value])
          }
          case 'select':
          case 'single': {
            return (d, c, f) => !c[f.value] || d[f.value] === c[f.value]
          }
          case 'multiple':
          case 'tags': {
            return (d, c, f) => c[f.value].length === 0 || c[f.value].includes(d[f.value])
          }
          case 'range':
          case 'time': {
            return (d, c, f) => (!c[f.value][0] || d[f.value] >= c[f.value][0]) && (!c[f.value][1] || d[f.value] <= c[f.value][1])
          }
          case 'date': {
            return (d, c, f) => (!c[f.value][0] || new Date(d[f.value]) >= new Date(c[f.value][0])) && (!c[f.value][1] || new Date(d[f.value]) <= new Date(c[f.value][1]))
          }
        }
      }
      let filtedDatas = datas
      this.filters.forEach((filter, index) => {
        filtedDatas = filtedDatas.filter(data => (filter.filter || getDefaultFilter(filter.type))(data, conditions, filter))
      })
      return filtedDatas
    },
    datalistOnChange (filter, conditions) {
      setTimeout(() => (filter.onChange || (() => {}))(conditions[filter.value], conditions), 50)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#custom-filter-container
  .custom-filter-group
    &:not(:last-child)
      margin-bottom: 15px
    .title
      padding: 0 5px
    .options
      & > div
        padding: 5px
      &.input
        & > div
          input[type="text"]
            width: 100%
            height: auto
            padding: 4px 10px
            box-sizing: border-box
      &.datalist
        & > div
          position: relative
          input[type="text"]
            width: 100%
            height: auto
            padding: 4px 10px
            box-sizing: border-box
            &::-webkit-calendar-picker-indicator
              opacity: 0
            &:focus
              & + .datalist
                display: inline
          .datalist
            display: none
            max-height: 300px
            min-width: 100%
            overflow: auto
            // left: 0
            top: 34px
            background: white
            box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.16)
            border-radius: 3px
            position: absolute
            z-index: 5
            user-select: none
            &:hover
              display: inline
            .option
              padding: 10px
              white-space: nowrap
              &:hover
                background: #999999
      &.select
        & > div
          select
            width: 100%
            height: auto
            padding: 4px 10px
            padding-right: 25px
            background-position: calc(100% - 12px) calc(15px - 6px), calc(100% - 5px) calc(15px - 6px), calc(100% - 12px) calc(15px - 4px), calc(100% - 5px) calc(15px - 4px)
            background-size: 7px 7px, 7px 7px, 7px 7px, 7px 7px
      &.single
        & > div
          display: flex
          label
            display: flex
            width: 100%
            padding: 3px
            &:hover
              background: #cccccc
              cursor: pointer
            input[type="radio"]
              margin-top: 4.5px
              margin-right: 5px
              padding: 1px 2px
            span
              word-break: break-all
      &.multiple
        & > div
          display: flex
          label
            display: flex
            width: 100%
            padding: 3px
            cursor: pointer
            &.disabled
              cursor: not-allowed
              img
                filter: opacity(50%)
              span
                color: #999999
            &:hover
              background: #cccccc
            input[type="checkbox"]
              margin-top: 4.5px
              margin-right: 5px
              padding: 1px 2px
            img
              margin-right: 5px
            span
              word-break: break-all
      &.range
        & > div
          display: flex
          input[type="number"]
            width: 100%
            height: auto
            flex: 1 1 auto
            padding: 1px 2px
          span
            padding: 0 5px
      &.date
        & > div
          display: flex
          input[type="date"]
            width: 100%
            height: auto
            padding: 4px 10px
            box-sizing: border-box
          span
            padding: 0 5px
      &.time
        & > div
          display: flex
          input[type="time"]
            width: 100%
            height: auto
            flex: 1 1 auto
            padding: 1px 2px
          span
            padding: 0 5px
      &.tags
        & > div
          &:first-child
            display: flex
            margin-bottom: 5px
            input[type="text"]
              width: 100%
              flex: 1 1 auto
              padding: 1px 2px
            button
              margin-left: 5px
              &:hover
                cursor: pointer
          &:not(:first-child)
            display: flex
            align-items: center
            &:not(:last-child)
              margin-bottom: 3px
            label
              display: flex
              width: 100%
              padding: 3px
              background: #cccccc
              &:hover
                & > button
                  visibility: visible
              span
                flex: 1 1 auto
                word-break: break-all
              button
                margin-left: 5px
                visibility: hidden
                &:hover
                  cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/tool/customFilter.vue